import type { TemplateSizes } from "@/types/layout";
import type { ExperienceState } from "@/types/state";

type ErrorViewProps = {
  experienceState: ExperienceState;
};

export default function ErrorView({ experienceState }: ErrorViewProps) {
  const template = experienceState.template as {
    getSizes(): TemplateSizes;
  };
  const metadata = experienceState.experienceData.metadata;

  const sizes = template.getSizes().player;
  const image = metadata.getSharedAssetUrl(
    "common/pixmoto-logo-stacked-onwhite-120.png",
  );

  // The ERROR status always carries the message string.
  const error = {
    __html: (experienceState.error as string).replace(/(?:\n)/g, "<br>"),
  };
  return (
    <div
      className="error"
      style={{
        width: sizes.container.width,
        height: sizes.container.height,
        marginTop: sizes.container.margins.top,
      }}
    >
      <div className="message-content tw:absolute tw:top-[50%] tw:left-[50%] tw:rounded-[10px] tw:bg-[#fff] tw:text-[20px] tw:text-light-text tw:[transform:translateX(-50%)_translateY(-50%)]">
        <span className="error-text" dangerouslySetInnerHTML={error} />
        <div
          className="error-image tw:h-[120px] tw:w-[120px] tw:bg-center tw:bg-contain tw:bg-no-repeat"
          style={{
            backgroundImage: `url("${image}")`,
          }}
        />
      </div>
    </div>
  );
}
